export default {
    namespaced: true,
    state: {
        id: 0,

        reverseSelectionMethod: false,
        selectedStatus: 2,
        odontogramMode: "treatments",
    },
    getters: {
        priceOfTreatment(state, getters, rootState, rootGetters) {
            return (id, currency) => {
                try {
                    if (typeof id === "undefined" || typeof currency === "undefined") return 0;
                    id = String(id);
                    currency = String(currency);
                    if (!rootState.dentalStates.hasOwnProperty(id) || !rootState.dentalStates[id].hasOwnProperty("price") || !rootState.dentalStates[id].price.hasOwnProperty(currency)) return 0;
                    const price = parseFloat(rootState.dentalStates[id].price[currency]);
                    if (isNaN(price)) return 0;
                    return price;
                } catch (error) {
                    captureException(error);
                    return 0;
                }
            };
        },

        priceOfVariation(state, getters, rootState, rootGetters) {
            return (protocol, stateId, currency) => {
                try {
                    const price = parseFloat(rootState.localSettings.protocols[protocol].variations[currency][String(stateId)]);
                    return isNaN(price) ? 0 : price;
                } catch (error) {
                    // console.error(e);
                    captureException(error);
                    return 0;
                }
            };
        },

        /**
         * Use: this.$store.getters["smart/titleOfTreatment"](id, $this.$store.state.language, true);
         */
        titleOfTreatment(state, getters, rootState, rootGetters) {
            return (id, language, addCategoryName = false) => {
                try {
                    if (typeof id === "undefined" || typeof language !== "string") return "";
                    id = String(id);
                    if (!rootState.dentalStates.hasOwnProperty(id) || !rootState.dentalStates[id].hasOwnProperty("title") || !rootState.dentalStates[id].title.hasOwnProperty(language)) return "";
                    let title = rootState.dentalStates[id].title[language];
                    if (addCategoryName) {
                        const group = rootState.dentalStates[id].group;
                        if (group < 5) title += " " + app.$t("plan_calculator.group_" + group).toLowerCase();
                    }
                    return title;
                } catch (error) {
                    captureException(error);
                    return "";
                }
            };
        },

        treatmentsByParent(state, getters, rootState, rootGetters) {
            return (id) => {
                if (typeof id === "undefined") return null;
                id = String(id);
                const ids = [];
                Object.keys(rootState.localSettings.dentalStates).forEach((key) => {
                    const item = rootState.localSettings.dentalStates[String(key)];
                    if (String(item.parent_id) !== id) return;
                    // if (parseInt(item.id) < 1000) return;
                    if (typeof item.hidden !== "undefined" && parseInt(item.hidden) === 1) return;
                    if (parseInt(item.status) === 0) return;
                    ids.push(item.id);
                });
                return ids;
            };
        },

        treatmentById(state, getters, rootState, rootGetters) {
            return (id) => {
                try {
                    if (typeof id === "undefined") return null;
                    id = String(id);
                    if (!rootState.localSettings.dentalStates.hasOwnProperty(id)) return null;
                    const treatment = rootState.localSettings.dentalStates[id];
                    state.id++;
                    const ret = {
                        id: state.id,
                        state_id: parseInt(id),
                        state_pid: parseInt(treatment.parent_id),
                        parent_id: 0,
                        title: typeof treatment.title[rootState.language] === "string" ? treatment.title[rootState.language] : "",
                        billable: parseInt(treatment.billable),
                        animate: parseInt(treatment.animate),
                        batch_price: parseInt(treatment.batch_price),
                        has_options: typeof treatment.hasOptions !== "undefined" && parseInt(treatment.hasOptions) === 1 ? 1 : 0,
                        group: parseInt(treatment.group),
                    };
                    return ret;
                } catch (error) {
                    captureException(error);
                    return null;
                }
            };
        },

        groupedTreatments(state, getters, rootState, rootGetters) {
            return (showInactives = false) => {
                const groupedItems = [];
                Object.keys(rootState.localSettings.dentalStates).forEach((id) => {
                    const item = rootState.localSettings.dentalStates[id];
                    // if (parseInt(item.id) < 1000) return;
                    if (typeof item.hidden !== "undefined" && parseInt(item.hidden) === 1) return;
                    if (!showInactives && parseInt(item.status) === 0) return;
                    if (typeof groupedItems[item.group] === "undefined") groupedItems[item.group] = [];
                    groupedItems[item.group].push(item);
                });
                return groupedItems;
            };
        },

        isProtocolAvailable(state, getters, rootState, rootGetters) {
            return (protocol) => {
                if (typeof protocol.require === 'undefined') return true;
                const ret = protocol.require.filter((id) => {
                    if (id === 9) id = 15;
                    const variationIds = app.$store.getters["smart/treatmentsByParent"](id);
                    return variationIds.length > 0;
                });
                return ret.length === protocol.require.length;
            };
        },
    },
};
